export enum SegmentEntityType {
    USER = 'user',
    DIRECT_REPORT = 'directReport',
    METRIC = 'metric',
    BEHAVIOUR = 'behaviour',
    SUB_BEHAVIOUR = 'subBehaviour',
}
